// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn-submit[data-v-e41c9c74] {\n  margin-top: 32px;\n  border-radius: 4px;\n  width: 100%;\n}\n\n", ""]);
// Exports
module.exports = exports;
